<template>
  <div
      class="progress-bar"
      role="progressbar"
      :aria-label="label"
      :aria-valuenow="percent"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-valuetext="`${percent}% abgeschlossen`"
  >
    <div class="progress-bar__fill" :style="{ width: percent + '%' }"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      default: 'Fortschritt'
    }
  },
  computed: {
    percent() {
      return Math.round((this.currentStep / this.totalSteps) * 100)
    }
  }
}
</script>

<style scoped>
#app-ves-clickstream .progress-bar {
  background: var(--primary-background-color);
  border-radius: 0px;
  overflow: hidden;
  height: 10px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

#app-ves-clickstream .progress-bar__fill {
  background: #69788c;
  height: 100%;
  transition: width 0.3s;
}

@media (forced-colors: active) {
  #app-ves-clickstream .progress-bar__fill {
    background-color: Highlight;
    border: 1px solid Highlight;
  }
}
</style>
